export const AVAILABLE_MODELS = [
  'ept2',
  'ept2_early',
  'ept2_rr',
  'ept2_hrrr',
  'ept1_5',
  'ept1_5_early',
  'aifs',
  'aurora',
];

export const AVAILABLE_VARIABLES = ['air_temperature_at_height_level_2m'];
